import type { RootState } from '@reducers/index';
import { updateQSO } from '@reducers/search';
import { FormGroup, FormLabel, Toggle } from '@sbt-web/ui';
import { QSOLabel } from '@tools/search/values';
import React from 'react';
import { connect } from 'react-redux';
import commonClasses from '../SelectorStyles/common.module.scss';
import { FilterURI } from '@sbt-web/network/types';

interface StateProps {
  qso: boolean;
}

interface DispatchProps {
  updateQSO: (qso: boolean) => void;
}

interface OwnProps {
  trackSearchConversion: () => void;
}

type QSOProps = StateProps & DispatchProps & OwnProps;

export const QSOComponent: React.FunctionComponent<QSOProps> = ({
  qso,
  updateQSO,
  trackSearchConversion,
}) => {
  const handleSelection = (isSelected: boolean) => {
    trackSearchConversion();
    updateQSO(isSelected);
  };

  return (
    <FormGroup>
      <FormLabel>Restringi ricerca</FormLabel>
      <Toggle
        name={FilterURI.QuerySubjectOnly}
        checked={qso}
        onInputChange={handleSelection}
        spaceBetweenElements
        classes={[commonClasses['custom-toggle']]}
      >
        {QSOLabel}
      </Toggle>
    </FormGroup>
  );
};

export const QSOSelector = connect<
  StateProps,
  DispatchProps,
  OwnProps,
  RootState
>(
  (state: RootState, ownProps: OwnProps) => ({
    qso: state.search.qso,
    trackSearchConversion: ownProps.trackSearchConversion,
  }),
  (dispatch) => ({
    updateQSO: (qso: boolean) => dispatch(updateQSO(qso)),
  })
)(QSOComponent);
